module.exports = __webpack_public_path__ + "img/img_07@2x.47d72b13.png";